import React from "react";

const GoogleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 48 48"
  >
    <path
      fill="#4285F4"
      d="M24 9.5c3.54 0 6.75 1.22 9.27 3.6l6.91-6.91C36.17 
         2.71 30.45 0 24 0 14.64 0 6.39 5.52 2.69 13.5l8.06 
         6.26C12.82 13.09 17.96 9.5 24 9.5z"
    />
    <path
      fill="#34A853"
      d="M46.1 24.5c0-1.55-.14-3.04-.41-4.5H24v9h12.6c-.54 
         2.88-2.16 5.33-4.6 6.97l7.14 5.54C43.54 37.64 46.1 
         31.45 46.1 24.5z"
    />
    <path
      fill="#FBBC05"
      d="M10.75 28.26c-.5-1.47-.75-3.05-.75-4.76s.25-3.29.75-4.76l-8.06
         -6.26C1.64 16.3 0 20.05 0 24s1.64 7.7 4.69 10.76l8.06
         -6.26z"
    />
    <path
      fill="#EA4335"
      d="M24 48c6.45 0 12.17-2.13 16.23-5.78l-7.14-5.54c-2.08 
         1.41-4.73 2.24-7.53 2.24-6.04 0-11.18-3.59-13.25
         -8.5l-8.06 6.26C6.39 42.48 14.64 48 24 48z"
    />
  </svg>
);

export default GoogleIcon;
